<div class="modal-wrapper px-4 pt-4 pb-2">
    <div class="d-flex justify-content-between align-items-center">
        <p class="h5 m-0">Encuesta de satisfacción</p>
        <button mat-icon-button (click)="_activeModal.dismiss()"><mat-icon>close</mat-icon></button>
    </div>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col">
            <div class="question-item" *ngFor="let pregunta of preguntas | orderByImpure: 'orden'">
                <div class="question-actions">
                    <div class="d-flex align-items-center">
                        <button class="btn btn-sm btn-outline-dark" (click)="subirPregunta(pregunta)" [disabled]="pregunta.orden == 1">
                            <mat-icon>keyboard_arrow_up</mat-icon>
                        </button>
                        <button class="ml-2 btn btn-sm btn-outline-dark" (click)="bajarPregunta(pregunta)" [disabled]="pregunta.orden == preguntas.length">
                            <mat-icon>keyboard_arrow_down</mat-icon>
                        </button>
                        <span class="ml-3 text-primary small pointer text-underline" (click)="duplicarPregunta(pregunta)">Duplicar</span>
                    </div>
                    <div class="d-flex">
                        <button class="btn btn-sm mr-2" *ngIf="pregunta.puedeEliminar" (click)="eliminarPregunta(pregunta)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <mat-slide-toggle color="primary" [(ngModel)]="pregunta.activo" (toggleChange)="activar_desactivarPregunta(pregunta)"></mat-slide-toggle>
                    </div>
                </div>
                <div class="question-content card p-3">
                    <div class="form-group">
                        <label class="control-label small">Título</label>
                        <ng-container *ngIf="pregunta.tipo == tipoPregunta.emoji">
                            <textarea class="form-control form-control-sm" name="question_title" 
                                rows="2" placeholder="Escriba aquí su pregunta" [(ngModel)]="pregunta.titulo"></textarea>
                        </ng-container>
                        <ng-container *ngIf="pregunta.tipo != tipoPregunta.emoji">
                            <input type="text" class="form-control form-control-sm" name="question_title" 
                                placeholder="Escriba aquí su pregunta" [(ngModel)]="pregunta.titulo">
                        </ng-container>
                    </div>
                    <ng-container [ngSwitch]="pregunta.tipo">
                        <ng-container *ngSwitchCase="tipoPregunta.emoji">
                            <div class="question-response-wrapper">
                                <div *ngFor="let respuesta of pregunta.respuestas" 
                                        class="question-emoji-item">
                                    <div class="d-flex justify-content-between w-100">
                                        <button class="btn btn-sm btn-outline-secondary border-0 p-0"
                                                [ngbPopover]="editarEmoji" placement="right" #popover="ngbPopover"
                                                [autoClose]="'outside'" matTooltip="Editar"
                                                (click)="configurarRespuestaEmoji(respuesta)">
                                            <mat-icon>edit_square</mat-icon>
                                        </button>
                                        <mat-slide-toggle color="primary" [(ngModel)]="respuesta.activo" 
                                            (toggleChange)="activar_desactivarRespuesta(respuesta)"></mat-slide-toggle>
                                    </div>
                                    <mat-icon class="emoji" [ngStyle]="{'color': respuesta.emojiColor}">{{respuesta.emoji}}</mat-icon>
                                    <span>{{respuesta.label}}</span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="tipoPregunta.abierta">
                            <textarea *ngFor="let respuesta of pregunta.respuestas" 
                                class="form-control form-control-sm" name="question_content"
                                rows="3" [(ngModel)]="respuesta.label"></textarea>
                        </ng-container>
                        <ng-container *ngSwitchCase="tipoPregunta.seleccionMultiple">
                            <div *ngFor="let respuesta of pregunta.respuestas; let i=index" 
                                    class="question-multiple-item">
                                <span>{{indexToChar(i)}}.</span>
                                <input type="text" class="form-control form-control-sm" 
                                    name="question_content" [(ngModel)]="respuesta.label">
                                <button class="btn btn-sm" *ngIf="respuesta.puedeEliminar" 
                                        (click)="eliminarRespuesta(pregunta, respuesta)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <div class="question-buttons">
                                <button class="btn btn-sm btn-secondary" (click)="nuevaRespuesta(pregunta)">
                                    Agregar campo
                                </button>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="tipoPregunta.checkbox">
                            <div class="question-response-wrapper">
                                <div *ngFor="let respuesta of pregunta.respuestas; let i=index" 
                                        class="form-group">
                                    <label class="control-label small">Check {{i+1}}</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control form-control-sm"
                                            [(ngModel)]="respuesta.label">
                                        <div class="input-group-append" *ngIf="respuesta.puedeEliminar">
                                            <button class="btn btn-sm" (click)="eliminarRespuesta(pregunta, respuesta)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="question-buttons">
                                <button class="btn btn-sm btn-secondary" (click)="nuevaRespuesta(pregunta)">
                                    Agregar campo
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="col">
            <p class="h6 mb-2">Vista previa</p>
            <div class="card p-4"
                [ngClass]="{'align-items-center': !hayPreguntasActivas }">
                <ng-container *ngIf="!hayPreguntasActivas">
                    <img src="assets/images/en-construccion.png" height="180" alt="Sin elementos">
                    <h6 class="mt-3 font-italic text-center">
                        No hay preguntas configuradas para esta encuesta
                    </h6>
                </ng-container>
                <div class="mb-4" *ngFor="let pregunta of preguntas | filterByImpure: ['activo']: true | orderByImpure: 'orden'; let i=index">
                    <h6 class="text-center font-weight-bold mb-3">{{i+1}}. {{pregunta.titulo}}</h6>
                    
                    <ng-container [ngSwitch]="pregunta.tipo">
                        <ng-container *ngSwitchCase="tipoPregunta.abierta">
                            <textarea *ngFor="let respuesta of pregunta.respuestas" class="form-control form-control-sm" 
                                name="question_response" rows="3" [(ngModel)]="respuesta.label"></textarea>
                        </ng-container>
                        <ng-container *ngSwitchCase="tipoPregunta.seleccionMultiple">
                            <div class="list-group">
                                <button *ngFor="let respuesta of pregunta.respuestas; let i=index"
                                        class="list-group-item list-group-item-action">
                                    {{indexToChar(i)}}. {{respuesta.label}}
                                </button>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="tipoPregunta.checkbox">
                            <mat-radio-group class="d-flex flex-wrap justify-content-around">
                                <mat-radio-button *ngFor="let respuesta of pregunta.respuestas"
                                        [value]="respuesta.label">
                                    {{respuesta.label}}
                                </mat-radio-button>
                            </mat-radio-group>
                        </ng-container>
                        <ng-container *ngSwitchCase="tipoPregunta.emoji">
                            <div class="question-response-wrapper">
                                <button *ngFor="let respuesta of pregunta.respuestas | filterByImpure: ['activo']: true"
                                        class="question-emoji-item">
                                    <mat-icon class="emoji" [ngStyle]="{'color': respuesta.emojiColor}">{{respuesta.emoji}}</mat-icon>
                                    <span>{{respuesta.label}}</span>
                                </button>
                            </div>
                        </ng-container>
                </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer px-4 py-2">
    <button type="button" class="btn btn-outline-secondary" (click)="_activeModal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="guardarPreguntas()">Guardar y finalizar</button>
</div>


<!--Template de ventana para editar los emojis-->
<ng-template #editarEmoji>
    <form [formGroup]="emojiConfigForm" (submit)="aplicarCambiosARespuestaEmoji()">
        <div class="btn-group-toggle" data-toggle="buttons">
            <label *ngFor="let emoji of emojiList" class="btn btn-outline-secondary"
                    (click)="setEmojiIcon(emoji)">
                <input type="radio" name="emojis" [id]="emoji" [value]="emoji">
                <mat-icon>{{emoji}}</mat-icon>
            </label>
        </div>
        <div class="d-flex align-items-center mb-3">
            <input type="text" class="flex-grow-1 form-control form-control-sm"
                placeholder="escriba el nombre del icono" formControlName="label" name="emoji_label">
            <input class="ml-2" type="color" value="#262626" formControlName="color" name="emoji_color">
        </div>
        <button class="btn btn-primary btn-block" [disabled]="emojiConfigForm.invalid">
            Guardar y finalizar
        </button>
    </form>
</ng-template>